import React from "react";

export default function ColorFrame15({ frameTextToggle, children }) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width="300"
      height="300"
      viewBox="0 0 300 300"
    >
      <g clipPath="url(#clip0_2087_157470)" transform={frameTextToggle}>
        <path
          d="M21.1542 244.231C5.18051 216.272 25.403 198.235 37.2975 183.195C39.0817 177.812 36.4244 162.993 52.928 159.193C70.2519 155.205 79.3339 173.427 80.4779 174.886C84.0999 179.503 91.6429 188.357 99.8194 184.665C100.262 186.317 96.9691 195.784 87.0697 191.633C87.5647 193.742 88.5546 195.325 89.5445 196.379C92.0194 199.016 92.966 199.319 96.9691 200.598C101.919 202.181 110.123 200.65 123.744 195.784C123.744 195.784 136.567 191.106 141.586 201.653C144.315 207.389 144.076 212.736 143.29 216.42C142.776 218.828 142.081 219.85 140.526 221.166C138.972 222.483 136.347 223.021 134.092 223.81C106.728 233.39 113.499 242.471 97.4275 249.93C80.0318 258.005 31.6916 262.674 21.1542 244.231Z"
          fill="black"
        />
        <path
          d="M39.6131 137.195C36.3713 130.711 62.5765 109.021 74.9265 100.724C80.5226 92.6189 79.5579 72.936 114.013 46.8811C148.83 20.5518 217.917 89.5314 232.389 118.67C229.181 126.199 225.323 135.917 221.183 146.457C219.409 150.973 228.916 148.19 224.285 166.14C217.917 183.507 208.075 184.665 200.549 184.665C168.71 218.821 174.29 247.791 190.5 264C198.563 272.063 103.371 277.171 86.8758 268.052C73.2616 260.527 68.0861 188.713 46.2806 173.662L54.6647 159.193C50.0334 154.562 42.855 143.678 39.6131 137.195Z"
          stroke="black"
          strokeWidth="5.78907"
        />
        <path
          d="M130.336 6.62194C110.273 11.868 108.118 36.5081 114.292 48.0431C116.258 49.6233 105.029 62.5158 120.081 62.5158C116.029 59.6379 118.344 50.087 128.765 53.8322C133.685 56.2985 168.486 61.0573 182.603 70.6205C200.549 82.7775 192.041 90.3877 197.655 97.2502C207.297 109.038 215.17 114.116 230.341 122.204C253.23 112.302 254.919 98.9181 229.884 58.821C198.591 8.69954 155.415 0.0643836 130.336 6.62194Z"
          fill="black"
          stroke="black"
          strokeWidth="3.47344"
        />
        <path
          d="M143.816 195.664C147.29 197.582 150.184 203.508 150.763 211.874"
          stroke="black"
          strokeWidth="5.78907"
          strokeLinecap="round"
        />
        <path
          d="M153.079 192.191C157.545 196.205 159.033 200.218 160.026 207.242"
          stroke="black"
          strokeWidth="5.78907"
          strokeLinecap="round"
        />

        <defs>
          <clipPath id="clip0_2087_157470">
            <rect width="276" height="276" fill="white" />
          </clipPath>
        </defs>
        {children}
      </g>
    </svg>
  );
}
